module.exports = __webpack_public_path__ + "doctor_11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_11.jpg
// module id = 887
// module chunks = 0